import { Observable } from 'rxjs';

import { ModelPrepped, ModelWithoutId } from 'app/type';

import { RestfulApiService } from './restful-api.service';
import { TaggingQualityQueue } from '../model/seam/tagging-quality-queue';

export class TagQualityService extends RestfulApiService<TaggingQualityQueue> {
    public next(): Observable<TaggingQualityQueue> {
        return this.http.get<TaggingQualityQueue>(`${this.getUrl()}/next`);
    }

    protected getFormName(): string {
        return 'tagging_quality_queue';
    }

    protected getPath(): string {
        return 'qa/tag-quality';
    }

    protected prepareSaveData(entity: ModelWithoutId<TaggingQualityQueue>): ModelPrepped<TaggingQualityQueue> {
        return {
            labeledAddress: entity.labeledAddress,
            labeledCity: entity.labeledCity,
            labeledState: entity.labeledState,
            labeledZip: entity.labeledZip,
            labeledCountry: entity.labeledCountry,
            labeledLongitude: entity.labeledLongitude,
            labeledLatitude: entity.labeledLatitude,
            status: entity.status,
            storePrimary: entity.storePrimary,
            storePayment: entity.storePayment,
            storeDistribution: entity.storeDistribution,
        };
    }
}

export const tagQualityService = new TagQualityService();
